// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon } from '@mantine/core';

import type { NavbarFooterItemProps } from 'app/Layout/NavBar/NavBarContent/NavBarFooter';
import { NavPopover } from 'app/Layout/NavBar/NavBarContent/NavPopover';
import { StyledNavLink } from 'app/Layout/NavBar/NavBarContent/StyledNavLink';
import { navbarTransitionStyle } from 'app/Layout/NavBar/useAppShell';
import { EvolveIcon } from 'assets/icons/EvolveIcon';

export const helpDeskItems = [
  {
    label: 'Knowledge Base',
    href: 'https://help-foresite.evolvemep.com/',
  },

  {
    label: 'Contact Support',
    href: 'https://www.evolvemep.com/contact-support/',
  },

  {
    label: 'EVOLVE University',
    href: 'https://learning.evolvemep.com/',
    isNew: true,
  },

  {
    label: 'Feature Request',
    href: 'https://evolveforesite.featureupvote.com/',
  },
  {
    label: 'Provide Feedback',
    href: 'https://evolvemep.com/shop/survey',
    isNew: true,
  },
  {
    label: 'Cookie Settings',
    onClick: () => {
      // @ts-expect-error cookies banner
      // oxlint-disable-next-line typescript/no-unsafe-call, typescript/no-unsafe-member-access
      window._hsp?.push(['showBanner']);
    },
  },
  {
    label: 'Privacy Policy',
    href: 'https://evolvemep.com/legal/privacy-policy',
  },
  {
    label: 'EULA',
    href: 'https://evolvemep.com/legal/eula',
  },
] as const satisfies {
  label: string;
  isNew?: true;
  href?: string;
  onClick?: () => void;
}[];

export const HelpDeskPopover = ({ navbarExpanded, popoverOpened, onPopoverChanged }: NavbarFooterItemProps) => (
  <NavPopover
    opened={popoverOpened}
    onChange={onPopoverChanged}
    position={navbarExpanded ? 'top-start' : 'right-end'}
    label="Help Desk"
    target={
      <ActionIcon
        className="nav-link-icon-collapsed"
        color="gray"
        size="input-sm"
        style={{
          'transition': navbarTransitionStyle,
          '--ai-hover': 'var(--mantine-color-app-shell-gray-7)',
        }}
      >
        <EvolveIcon icon="Help" />
      </ActionIcon>
    }
  >
    {helpDeskItems.map((props) => (
      <StyledNavLink
        key={props.label}
        {...props}
        onClick={() => {
          if ('href' in props) {
            window.open(props.href, '_blank');
          }
          if ('onClick' in props) {
            props.onClick();
          }
          onPopoverChanged(false);
        }}
      />
    ))}
  </NavPopover>
);
